import { jsx as t } from "react/jsx-runtime";
import { Close as i } from "@videoblocks/react-icons";
function s({ size: e, onClick: r }) {
  return /* @__PURE__ */ t(
    "button",
    {
      style: e === "small" ? { width: "6px", height: "6px" } : { width: "8px", height: "8px" },
      onClick: r,
      children: /* @__PURE__ */ t(i, { className: "block fill-current" })
    }
  );
}
export {
  s as BadgeButton
};
